import {minmax, sectionToFixedMap, portrait} from '../shared.js';
import {buildNarrativeTextTimeline, dashPaths} from '../animations.js';

const article = document.querySelector('#chapter17');

const narrativeSection = article.querySelector('#chapter17-narrative');
const narrativeFixed = sectionToFixedMap.get(narrativeSection);
const narrativeText = narrativeFixed.querySelector('.narrative-text');
const narrativeTimeline = new TimelineLite({paused: true});

const leadershipSection = article.querySelector('#chapter17-leadership');
const leadershipFixed = sectionToFixedMap.get(leadershipSection);
const leadershipScroll = leadershipFixed.querySelector('.scroll-container');
const leadershipRow = leadershipFixed.querySelector('.scroll-container > div:nth-of-type(1)');
const leadershipXPaths = Array.from(leadershipRow.querySelectorAll('svg path'));
const followLineRow = leadershipFixed.querySelector('.scroll-container > div:nth-of-type(2)');
const followTextRow = leadershipFixed.querySelector('.scroll-container > div:nth-of-type(3)');
const followTreeRow = leadershipFixed.querySelector('.scroll-container > div:nth-of-type(4)');
const flagsRow = leadershipFixed.querySelector('.scroll-container > div:nth-of-type(5)');
const linesRow = leadershipFixed.querySelector('.scroll-container > div:nth-of-type(6)');
const leadersRow = leadershipFixed.querySelector('.scroll-container > div:nth-of-type(7)');
const zawahiri = leadersRow.querySelector('figure:nth-of-type(1)');
const baghdadi = leadersRow.querySelector('figure:nth-of-type(2)');
const leadershipTimeline = new TimelineLite({paused: true});
const leadershipAltTimeline = new TimelineLite({paused: true});

/**
 * Initialize chapter
 */
export function init() {
  console.log('chapter17:init');

  initNarrative();
  initLeadership();
}

/**
 * Init narrative section
 */
function initNarrative() {
  buildNarrativeTextTimeline(narrativeTimeline, narrativeText, 85);

  narrativeSection.addEventListener('scrub', ({detail: {vh}}) => narrativeTimeline.seek(minmax(0, vh, narrativeTimeline.duration())));
}

/**
 * Init leadership section
 */
function initLeadership() {
  const trunks = Array.from(followTreeRow.querySelectorAll('svg path:nth-of-type(1)'));
  const branches = Array.from(followTreeRow.querySelectorAll('svg path:nth-of-type(n+2)'));

  TweenLite.set([leadershipRow, followTextRow, flagsRow, leadersRow], {opacity: 0});
  dashPaths([...leadershipXPaths, followLineRow.querySelector('path'), ...trunks, ...branches, ...linesRow.querySelectorAll('path')]);

  leadershipTimeline.to({}, 125, {});

  leadershipTimeline.add([
    TweenLite.to(leadershipRow, 25, {opacity: 1}),
    TweenLite.to(leadershipScroll, 25, {top: `-=${(100 * 1/3)}vh`}),
  ]);

  leadershipXPaths.forEach(path => leadershipTimeline.to(path, 25, {attr: {'stroke-dashoffset': 0}}));

  leadershipTimeline.to(leadershipScroll, 100 * 2/3, {top: `-=${100 * 2/3}vh`});

  leadershipTimeline.to(followLineRow.querySelector('path'), 50, {attr: {'stroke-dashoffset': 0}}, '-=40');

  leadershipTimeline.to(followTextRow, 25, {opacity: 1}, '-=10');

  leadershipTimeline.to(leadershipScroll, 50, {top: '-=50vh'});
  leadershipTimeline.to(trunks, 25, {attr: {'stroke-dashoffset': 0}}, '-=35');
  leadershipTimeline.to(branches, 25, {attr: {'stroke-dashoffset': 0}}, '-=10');

  leadershipTimeline.to({}, 25, {});

  leadershipTimeline.to(flagsRow, 25, {opacity: 1});

  leadershipTimeline.add([
    TweenLite.to(leadershipScroll, 90, {top: '-=90vh'}),
    TweenLite.to([...linesRow.querySelectorAll('path')], 50, {attr: {'stroke-dashoffset': 0}}),
  ]);

  leadershipTimeline.to(leadersRow, 50, {opacity: 1});

  leadershipTimeline.add([
    TweenLite.to(leadershipScroll, 100, {top: '-=100vh'}),
    TweenLite.to(zawahiri, 50, {opacity: 0}),
    TweenLite.to(baghdadi, 100, {left: '-=25vw', top: '+=100vh', scale: 1.25}),
  ]);

  // now alt timeline
  leadershipAltTimeline.to({}, 125, {});

  leadershipAltTimeline.add([
    TweenLite.to(leadershipRow, 25, {opacity: 1}),
    TweenLite.to(leadershipScroll, 25, {top: `-=${(100 * 1/5)}vh`}),
  ]);

  leadershipXPaths.forEach(path => leadershipAltTimeline.to(path, 25, {attr: {'stroke-dashoffset': 0}}));

  leadershipAltTimeline.to(leadershipScroll, 50, {top: '-=50vh'});

  leadershipAltTimeline.to(followLineRow.querySelector('path'), 50, {attr: {'stroke-dashoffset': 0}}, '-=50');

  leadershipAltTimeline.to(followTextRow, 25, {opacity: 1}, '-=25');

  leadershipAltTimeline.to({}, 25, {});

  leadershipAltTimeline.to(leadershipScroll, 25, {top: '-=25vh'});
  leadershipAltTimeline.to(trunks, 25, {attr: {'stroke-dashoffset': 0}}, '-=25');
  leadershipAltTimeline.to(branches, 25, {attr: {'stroke-dashoffset': 0}});

  leadershipAltTimeline.to({}, 25, {});

  leadershipAltTimeline.to(flagsRow, 25, {opacity: 1});

  leadershipAltTimeline.add([
    TweenLite.to(leadershipScroll, 50, {top: '-=50vh'}),
    TweenLite.to([...linesRow.querySelectorAll('path')], 25, {attr: {'stroke-dashoffset': 0}}),
  ]);

  leadershipAltTimeline.to(leadersRow, 50, {opacity: 1});

  leadershipAltTimeline.add([
    TweenLite.to(leadershipScroll, 100, {top: '-=100vh'}),
    TweenLite.to(zawahiri, 50, {opacity: 0}),
    TweenLite.to(baghdadi, 100, {left: '-=25vw', top: '+=100vh', scale: 1.75}),
  ]);

  leadershipSection.addEventListener('scrub', ({detail: {vh}}) => {
    if (portrait.matches) {
      leadershipAltTimeline.seek(minmax(0, vh, leadershipTimeline.duration()));
    } else {
      leadershipTimeline.seek(minmax(0, vh, leadershipTimeline.duration()));
    }
  }, false);
}
